import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CvpLogoType } from "./CvpLogoType";

export interface SetLogoResponse extends BackendResponse {
  item: string;
}

export interface SetLogoParameters extends NextApiParams {
  cvportalLogoType: CvpLogoType;
  idEmbed: string;
  idDocumentToKeep: number;
}

export const usePreviewedLogo = withNextApi<SetLogoResponse, SetLogoParameters>(
  "/cvp/CvpUsePreviewedLogo"
);
